import * as React from "react";
import { Routes, Route, Navigate, useParams, useNavigate, useSearchParams } from "react-router-dom";
import ProjectPicker from "./components/ProjectPicker";
import ProjectDashboard from "./components/Dashboard/ProjectDashboard";
import HealReportPage from "./components/HealReportPage";
import ScoutReportPage from "./components/ScoutReportPage";
import NoSubscriptionPage from "./components/NoSubscriptionPage";

const App: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<ProjectPicker />} />
            <Route path="/no-subscription" element={<NoSubscriptionPage />} />
            <Route
                path="/dashboard/:resourceId/:projectId"
                element={<ProjectDashboardPage />}
            />
            <Route path="/heal/:sessionId" element={<HealReportRoute />} />
            <Route path="/scout/:sessionId" element={<ScoutReportRoute />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

const ProjectDashboardPage: React.FC = () => {
    const { resourceId, projectId } = useParams();

    if (!resourceId || !projectId) return <Navigate to="/" replace />;

    return (
        <ProjectDashboard
            resourceId={decodeURIComponent(resourceId)}
            projectId={decodeURIComponent(projectId)}
        />
    );
};

/**
 * Heal report deep link: /heal/:sessionId?resourceId=<arm-id>&projectId=<projectId>
 * resourceId/projectId travel as query params (not path segments) because
 * resourceId is an ARM ID with embedded slashes that break path-based routing.
 */
const HealReportRoute: React.FC = () => {
    const { sessionId } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const resourceId = searchParams.get("resourceId");
    const projectId = searchParams.get("projectId");

    React.useEffect(() => {
        if (!sessionId || !resourceId || !projectId) {
            navigate("/", { replace: true });
        }
    }, [sessionId, resourceId, projectId, navigate]);

    if (!sessionId || !resourceId || !projectId) return null;

    return (
        <HealReportPage
            sessionId={sessionId}
            resourceId={resourceId}
            projectId={projectId}
        />
    );
};

/**
 * Scout report deep link: /scout/:sessionId?resourceId=<arm-id>&projectId=<projectId>
 */
const ScoutReportRoute: React.FC = () => {
    const { sessionId } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const resourceId = searchParams.get("resourceId");
    const projectId = searchParams.get("projectId");

    React.useEffect(() => {
        if (!sessionId || !resourceId || !projectId) {
            navigate("/", { replace: true });
        }
    }, [sessionId, resourceId, projectId, navigate]);

    if (!sessionId || !resourceId || !projectId) return null;

    return (
        <ScoutReportPage
            sessionId={sessionId}
            resourceId={resourceId}
            projectId={projectId}
        />
    );
};

export default App;


